import * as Types from '../../types/bff/gql-schema';

import { useMutation, useQuery, UseMutationOptions, UseQueryOptions } from '@tanstack/react-query';
import { gqlFetcher } from '@/utils/fetcher';

export const InsertMagazineLikeDocument = `
    mutation InsertMagazineLike($magazinePid: ID!) {
  insertMagazineLike(magazinePid: $magazinePid)
}
    `;
export const useInsertMagazineLikeMutation = <
      TError = Types.GraphqlError,
      TContext = unknown
    >(options?: UseMutationOptions<Types.InsertMagazineLikeMutation, TError, Types.InsertMagazineLikeMutationVariables, TContext>) =>
    useMutation<Types.InsertMagazineLikeMutation, TError, Types.InsertMagazineLikeMutationVariables, TContext>(
      ['InsertMagazineLike'],
      (variables?: Types.InsertMagazineLikeMutationVariables) => gqlFetcher<Types.InsertMagazineLikeMutation, Types.InsertMagazineLikeMutationVariables>(InsertMagazineLikeDocument, 'InsertMagazineLike', variables)(),
      options
    );
useInsertMagazineLikeMutation.fetcher = (variables: Types.InsertMagazineLikeMutationVariables, options?: RequestInit['headers']) => gqlFetcher<Types.InsertMagazineLikeMutation, Types.InsertMagazineLikeMutationVariables>(InsertMagazineLikeDocument, 'InsertMagazineLike', variables, options);
export const DeleteMagazineLikeDocument = `
    mutation DeleteMagazineLike($magazinePid: ID!) {
  deleteMagazineLike(magazinePid: $magazinePid)
}
    `;
export const useDeleteMagazineLikeMutation = <
      TError = Types.GraphqlError,
      TContext = unknown
    >(options?: UseMutationOptions<Types.DeleteMagazineLikeMutation, TError, Types.DeleteMagazineLikeMutationVariables, TContext>) =>
    useMutation<Types.DeleteMagazineLikeMutation, TError, Types.DeleteMagazineLikeMutationVariables, TContext>(
      ['DeleteMagazineLike'],
      (variables?: Types.DeleteMagazineLikeMutationVariables) => gqlFetcher<Types.DeleteMagazineLikeMutation, Types.DeleteMagazineLikeMutationVariables>(DeleteMagazineLikeDocument, 'DeleteMagazineLike', variables)(),
      options
    );
useDeleteMagazineLikeMutation.fetcher = (variables: Types.DeleteMagazineLikeMutationVariables, options?: RequestInit['headers']) => gqlFetcher<Types.DeleteMagazineLikeMutation, Types.DeleteMagazineLikeMutationVariables>(DeleteMagazineLikeDocument, 'DeleteMagazineLike', variables, options);
export const GetQuestionRelatedMagazinesDocument = `
    query GetQuestionRelatedMagazines($request: QuestionRelatedMagazinesRequestInput!) {
  questionRelatedMagazines(request: $request) {
    description
    title
    magazinePid
    createdAt
    titleImageUrl
  }
}
    `;
export const useGetQuestionRelatedMagazinesQuery = <
      TData = Types.GetQuestionRelatedMagazinesQuery,
      TError = Types.GraphqlError
    >(
      variables: Types.GetQuestionRelatedMagazinesQueryVariables,
      options?: UseQueryOptions<Types.GetQuestionRelatedMagazinesQuery, TError, TData>,
    ) =>
    useQuery<Types.GetQuestionRelatedMagazinesQuery, TError, TData>(
      ['GetQuestionRelatedMagazines', variables],
      gqlFetcher<Types.GetQuestionRelatedMagazinesQuery, Types.GetQuestionRelatedMagazinesQueryVariables>(GetQuestionRelatedMagazinesDocument, 'GetQuestionRelatedMagazines', variables),
      options
    );

useGetQuestionRelatedMagazinesQuery.getKey = (variables: Types.GetQuestionRelatedMagazinesQueryVariables) => ['GetQuestionRelatedMagazines', variables];
;

useGetQuestionRelatedMagazinesQuery.fetcher = (variables: Types.GetQuestionRelatedMagazinesQueryVariables, options?: RequestInit['headers']) => gqlFetcher<Types.GetQuestionRelatedMagazinesQuery, Types.GetQuestionRelatedMagazinesQueryVariables>(GetQuestionRelatedMagazinesDocument, 'GetQuestionRelatedMagazines', variables, options);
export const GetMagazineTagListPageDocument = `
    query GetMagazineTagListPage($request: TagMagazineCursorPageRequestInput!) {
  tagMagazineCursorPage(request: $request) {
    pivot
    elements {
      createdAt
      description
      magazinePid
      mobileContent
      mobileDescription
      mobileTitle
      title
      titleImageUrl
      content
    }
  }
}
    `;
export const useGetMagazineTagListPageQuery = <
      TData = Types.GetMagazineTagListPageQuery,
      TError = Types.GraphqlError
    >(
      variables: Types.GetMagazineTagListPageQueryVariables,
      options?: UseQueryOptions<Types.GetMagazineTagListPageQuery, TError, TData>,
    ) =>
    useQuery<Types.GetMagazineTagListPageQuery, TError, TData>(
      ['GetMagazineTagListPage', variables],
      gqlFetcher<Types.GetMagazineTagListPageQuery, Types.GetMagazineTagListPageQueryVariables>(GetMagazineTagListPageDocument, 'GetMagazineTagListPage', variables),
      options
    );

useGetMagazineTagListPageQuery.getKey = (variables: Types.GetMagazineTagListPageQueryVariables) => ['GetMagazineTagListPage', variables];
;

useGetMagazineTagListPageQuery.fetcher = (variables: Types.GetMagazineTagListPageQueryVariables, options?: RequestInit['headers']) => gqlFetcher<Types.GetMagazineTagListPageQuery, Types.GetMagazineTagListPageQueryVariables>(GetMagazineTagListPageDocument, 'GetMagazineTagListPage', variables, options);
export const GetMagazineRelatedMagazinesDocument = `
    query GetMagazineRelatedMagazines($request: MagazineRelatedMagazinesRequestInput!) {
  magazineRelatedMagazines(request: $request) {
    title
    mobileTitle
    description
    mobileDescription
    content
    mobileContent
    createdAt
    titleImageUrl
    magazinePid
    contentType
  }
}
    `;
export const useGetMagazineRelatedMagazinesQuery = <
      TData = Types.GetMagazineRelatedMagazinesQuery,
      TError = Types.GraphqlError
    >(
      variables: Types.GetMagazineRelatedMagazinesQueryVariables,
      options?: UseQueryOptions<Types.GetMagazineRelatedMagazinesQuery, TError, TData>,
    ) =>
    useQuery<Types.GetMagazineRelatedMagazinesQuery, TError, TData>(
      ['GetMagazineRelatedMagazines', variables],
      gqlFetcher<Types.GetMagazineRelatedMagazinesQuery, Types.GetMagazineRelatedMagazinesQueryVariables>(GetMagazineRelatedMagazinesDocument, 'GetMagazineRelatedMagazines', variables),
      options
    );

useGetMagazineRelatedMagazinesQuery.getKey = (variables: Types.GetMagazineRelatedMagazinesQueryVariables) => ['GetMagazineRelatedMagazines', variables];
;

useGetMagazineRelatedMagazinesQuery.fetcher = (variables: Types.GetMagazineRelatedMagazinesQueryVariables, options?: RequestInit['headers']) => gqlFetcher<Types.GetMagazineRelatedMagazinesQuery, Types.GetMagazineRelatedMagazinesQueryVariables>(GetMagazineRelatedMagazinesDocument, 'GetMagazineRelatedMagazines', variables, options);
export const GetPrevNextMagazinePidDocument = `
    query GetPrevNextMagazinePid($magazinePid: ID!, $contentType: String) {
  prevMagazinePid(magazinePid: $magazinePid, contentType: $contentType)
  nextMagazinePid(magazinePid: $magazinePid, contentType: $contentType)
}
    `;
export const useGetPrevNextMagazinePidQuery = <
      TData = Types.GetPrevNextMagazinePidQuery,
      TError = Types.GraphqlError
    >(
      variables: Types.GetPrevNextMagazinePidQueryVariables,
      options?: UseQueryOptions<Types.GetPrevNextMagazinePidQuery, TError, TData>,
    ) =>
    useQuery<Types.GetPrevNextMagazinePidQuery, TError, TData>(
      ['GetPrevNextMagazinePid', variables],
      gqlFetcher<Types.GetPrevNextMagazinePidQuery, Types.GetPrevNextMagazinePidQueryVariables>(GetPrevNextMagazinePidDocument, 'GetPrevNextMagazinePid', variables),
      options
    );

useGetPrevNextMagazinePidQuery.getKey = (variables: Types.GetPrevNextMagazinePidQueryVariables) => ['GetPrevNextMagazinePid', variables];
;

useGetPrevNextMagazinePidQuery.fetcher = (variables: Types.GetPrevNextMagazinePidQueryVariables, options?: RequestInit['headers']) => gqlFetcher<Types.GetPrevNextMagazinePidQuery, Types.GetPrevNextMagazinePidQueryVariables>(GetPrevNextMagazinePidDocument, 'GetPrevNextMagazinePid', variables, options);
export const GetMagazineRelatedQuestionCardsDocument = `
    query GetMagazineRelatedQuestionCards($request: MagazineRelatedQuestionCardsRequestInput!) {
  magazineRelatedQuestionCards(request: $request) {
    answeredStatus
    answererCount
    answererProfileImageUrls
    question {
      status
      title
      attachments {
        blindType
        questionAttachmentId
      }
      questionPid
      content
      category {
        name
        iconImageUrl
        questionCategoryId
      }
      tags {
        name
        questionTagId
      }
      createdAt
      isBlockedByMe
    }
  }
}
    `;
export const useGetMagazineRelatedQuestionCardsQuery = <
      TData = Types.GetMagazineRelatedQuestionCardsQuery,
      TError = Types.GraphqlError
    >(
      variables: Types.GetMagazineRelatedQuestionCardsQueryVariables,
      options?: UseQueryOptions<Types.GetMagazineRelatedQuestionCardsQuery, TError, TData>,
    ) =>
    useQuery<Types.GetMagazineRelatedQuestionCardsQuery, TError, TData>(
      ['GetMagazineRelatedQuestionCards', variables],
      gqlFetcher<Types.GetMagazineRelatedQuestionCardsQuery, Types.GetMagazineRelatedQuestionCardsQueryVariables>(GetMagazineRelatedQuestionCardsDocument, 'GetMagazineRelatedQuestionCards', variables),
      options
    );

useGetMagazineRelatedQuestionCardsQuery.getKey = (variables: Types.GetMagazineRelatedQuestionCardsQueryVariables) => ['GetMagazineRelatedQuestionCards', variables];
;

useGetMagazineRelatedQuestionCardsQuery.fetcher = (variables: Types.GetMagazineRelatedQuestionCardsQueryVariables, options?: RequestInit['headers']) => gqlFetcher<Types.GetMagazineRelatedQuestionCardsQuery, Types.GetMagazineRelatedQuestionCardsQueryVariables>(GetMagazineRelatedQuestionCardsDocument, 'GetMagazineRelatedQuestionCards', variables, options);
export const GetMagazineRelatedBoardPostsDocument = `
    query GetMagazineRelatedBoardPosts($request: MagazineRelatedBoardPostsRequestInput!) {
  magazineRelatedBoardPosts(request: $request) {
    title
    content
    blinded
    boardPostPid
    boardPostAttachments {
      blindType
      boardPostAttachmentId
    }
  }
}
    `;
export const useGetMagazineRelatedBoardPostsQuery = <
      TData = Types.GetMagazineRelatedBoardPostsQuery,
      TError = Types.GraphqlError
    >(
      variables: Types.GetMagazineRelatedBoardPostsQueryVariables,
      options?: UseQueryOptions<Types.GetMagazineRelatedBoardPostsQuery, TError, TData>,
    ) =>
    useQuery<Types.GetMagazineRelatedBoardPostsQuery, TError, TData>(
      ['GetMagazineRelatedBoardPosts', variables],
      gqlFetcher<Types.GetMagazineRelatedBoardPostsQuery, Types.GetMagazineRelatedBoardPostsQueryVariables>(GetMagazineRelatedBoardPostsDocument, 'GetMagazineRelatedBoardPosts', variables),
      options
    );

useGetMagazineRelatedBoardPostsQuery.getKey = (variables: Types.GetMagazineRelatedBoardPostsQueryVariables) => ['GetMagazineRelatedBoardPosts', variables];
;

useGetMagazineRelatedBoardPostsQuery.fetcher = (variables: Types.GetMagazineRelatedBoardPostsQueryVariables, options?: RequestInit['headers']) => gqlFetcher<Types.GetMagazineRelatedBoardPostsQuery, Types.GetMagazineRelatedBoardPostsQueryVariables>(GetMagazineRelatedBoardPostsDocument, 'GetMagazineRelatedBoardPosts', variables, options);